export default "__VITE_ASSET__BydC8MDz__"